const getRoute = [{
  id: '1',
  title: '交易',
  children: [{
    id: '1-1',
    img: require('@/assets/menu/trade.png'),
    title: '币币交易',
    url: '/coin'
  }]
}, {
  id: '2',
  title: '合约',
  children: [{
    id: '2-1',
    img: require('@/assets/menu/delivery.png'),
    title: '交割合约',
    url: '/micro'
  }, {
    id: '2-2',
    img: require('@/assets/menu/perpetual.png'),
    title: '永续合约',
    url: '/lever'
  }]
}, {
  id: '3',
  title: '衍生品',
  url: '/forex'
}, {
  id: '4',
  title: 'AI超算量化',
  url: '/mining'
}, {
  id: '5',
  title: '我的资产',
  url: '/assets/detail'
},
//  {
//   id: '6',
//   title: 'IEO启动版',
//   url: '/subscription'
// },
{
  id: '7',
  title: '快速充值',
  url: '/recharge'
},
// {
//   id: '8',
//   title: '信用借款',
//   url: '/loan'
// },
{
  id: '9',
  title: '联系客服',
  url: 'service'
}]
export default getRoute